import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="chat"
export default class extends Controller {

  static targets = ["chat_details"];
  
  showConversation(event) {
    const type = event.currentTarget.dataset.type;
    const id = event.currentTarget.dataset.id;
    const chatUrl = `/students/chat_details/${type}/${id}`;

    fetch(chatUrl)
      .then((response) => response.text())
      .then((html) => {
        //window.scrollTo(0, 0);
        document.querySelector('#chat_details').innerHTML = html;
      });
  }
}
